module.exports = __webpack_public_path__ + "static/media/battery wind.bcb06682.png";